import React from 'react'
import { StyleSheet, View } from 'react-native'
import { BtInput, BtRadioButton, BtText } from '@linqpal/components/src/ui'
import { currencyMask } from '../../../../../../utils/helpers/masking'
import { useTranslation } from 'react-i18next'
import { PaymentTypeOptions } from '../types'

interface PaymentTypeSelectorProps {
  paymentType: PaymentTypeOptions
  onPaymentTypeChange: (type: PaymentTypeOptions) => void
  totalAmount: number
  partialAmount: string
  onPartialAmountChange: (value: string) => void
}

export const PaymentTypeSelector: React.FC<PaymentTypeSelectorProps> = ({
  paymentType,
  onPaymentTypeChange,
  totalAmount,
  partialAmount,
  onPartialAmountChange,
}) => {
  const { t } = useTranslation('global')

  return (
    <View style={styles.radioGroup}>
      <View style={styles.radioRowWithAmount}>
        <BtRadioButton
          checked={paymentType === PaymentTypeOptions.Full}
          onPress={() => onPaymentTypeChange(PaymentTypeOptions.Full)}
          label={t('payIhcInvoice.selectOptionToPay.payRemainingAmount')}
          labelStyle={styles.label}
        />
        {paymentType === PaymentTypeOptions.Full && (
          <BtText style={styles.remainingAmount}>
            {currencyMask(totalAmount)}
          </BtText>
        )}
      </View>
      <View style={styles.radioRowWithAmount}>
        <BtRadioButton
          checked={paymentType === PaymentTypeOptions.Partial}
          onPress={() => onPaymentTypeChange(PaymentTypeOptions.Partial)}
          label={t('payIhcInvoice.selectOptionToPay.payPartialAmount')}
          containerStyle={{ marginTop: 5 }}
          labelStyle={styles.label}
        />
        {paymentType === PaymentTypeOptions.Partial && (
          <BtInput
            model={{ amount: partialAmount || '0.00' }}
            name="amount"
            style={styles.amountInput}
            textStyle={styles.amountInputText}
            onChangeText={onPartialAmountChange}
            maskType="money"
            maskOptions={{
              separator: '.',
              unit: '$',
              delimiter: ',',
            }}
            autoComplete="off"
            keyboardType="decimal-pad"
            size="sm"
          />
        )}
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  radioGroup: {},
  radioRowWithAmount: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: 44,
  },
  remainingAmount: {
    fontSize: 14,
    lineHeight: 20,
    fontWeight: '700',
    fontFamily: 'Inter',
    textAlign: 'right',
    textAlignVertical: 'center',
    color: '#001929',
  },
  amountInput: {
    width: 153,
    marginLeft: 'auto',
    alignSelf: 'center',
  },
  amountInputText: {
    fontSize: 14,
    lineHeight: 16,
    fontWeight: '600',
    fontFamily: 'Inter',
    textAlign: 'left',
    textAlignVertical: 'center',
    color: '#001929',
  },
  label: {
    fontSize: 14,
    fontWeight: '500',
    lineHeight: 24,
    color: '#001929',
    fontFamily: 'Inter',
    letterSpacing: -0.5,
    marginLeft: 12,
  },
})
